<script>
    import axios from "axios";

    export default {
        name: "FindPlaceByBarcodeMixin",

        methods: {
            findPlaceByBarcode(barcode) {
                return new Promise(((resolve, reject) => {
                    if (barcode && barcode.length > 0) {
                        axios({
                            url: process.env.VUE_APP_BACKEND_URL + '/api/places',
                            method: 'GET',
                            params: {
                                filter: JSON.stringify([
                                    {
                                        key: 'barcode',
                                        value: this.barcode,
                                        operation: '=',
                                    },
                                ]),
                            },
                        }).then(resp => {
                            if (resp.data.list && resp.data.list.length > 0) {
                                if (resp.data.list.length > 1) {
                                    let acceptedPlace = resp.data.list.filter(p => p.accepted);
                                    if (acceptedPlace.length > 0) {
                                        resolve(acceptedPlace[0]);
                                    } else {
                                        resolve(resp.data.list[0]);
                                    }
                                } else {
                                    resolve(resp.data.list[0]);
                                }
                            } else {
                                this.showErrors('Место не найдено');
                                resolve(null);
                            }
                        }).catch(err => {
                            this.showErrors(err.response.data.errors);
                            reject(err.response.data.errors);
                        })
                    } else {
                        resolve(null);
                    }
                }));
            },
        },
    }
</script>